import Cookies from './components/Cookies';
import Header from './components/Header';
import AspectRatio from './components/AspectRatio';
import HeroGallery from './components/HeroGallery';
import EventDates from './components/EventDates';
import FilterNav from './components/FilterNav';
import ImgTextSlider from './components/ImgTextSlider';
import CoverflowSlider from './components/CoverflowSlider';
import EventSlider from './components/EventSlider';
import DesktopSlider from './components/DesktopSlider';
import Loader from './components/Loader';
import Video from './components/Video';
import Modal from './components/Modal';
import LayoutSelect from './components/LayoutSelect';
import MasonryGrid from './components/MasonryGrid';
import '../scss/base/_reset.scss';
import '../scss/base/_base.scss';
import '../scss/base/_animations.scss';
import '../scss/base/_helpers.scss';
import '../scss/base/_images.scss';
import '../scss/base/_typography.scss';
import '../scss/components/_forms.scss';
import '../scss/components/_buttons.scss';
import '../scss/components/_socials.scss';
import '../scss/components/_cookies.scss';
import '../scss/components/_video.scss';
import 'swiper/css/bundle';
import 'plyr/dist/plyr.css';
import '../scss/components/_hero_gallery.scss';
import '../scss/components/_hero_block.scss';
import '../scss/components/_section_header.scss';
import '../scss/components/_section_nav.scss';
import '../scss/components/_artists_list.scss';
import '../scss/components/_coverflow_slider.scss';
import '../scss/components/_events_slider.scss';
import '../scss/components/_img_text_slider.scss';
import '../scss/components/_shop_slider.scss';
import '../scss/components/_live_dates.scss';
import '../scss/components/_slider.scss';
import '../scss/components/_banner.scss';
import '../scss/components/_modal.scss';
import '../scss/components/_text_block.scss';
import '../scss/components/_article_nav.scss';
import '../scss/components/_label_sticker.scss';
import '../scss/layout/_header.scss';
import '../scss/layout/_footer.scss';
import '../scss/layout/_loader.scss';
import '../scss/layout/_grid_block.scss';
import '../scss/layout/_masonry_grid.scss';
import '../scss/pages/_home.scss';
import '../scss/pages/_artists.scss';
import '../scss/pages/_terms.scss';
import '../scss/pages/_news.scss';

class Communion {
  constructor(components) {
    Object.keys(components).forEach((component) => {
      const Component = components[component];
      const elements = document.querySelectorAll(
        `[data-component="${component}"]`
      );

      [...elements].forEach((element) => {
        new Component({ root: element });
      });
    });
  }
}

new Communion({
  cookies: Cookies,
  header: Header,
  aspectRatio: AspectRatio,
  heroGallery: HeroGallery,
  eventDates: EventDates,
  filterNav: FilterNav,
  imgTextSlider: ImgTextSlider,
  coverflowSlider: CoverflowSlider,
  eventSlider: EventSlider,
  desktopSlider: DesktopSlider,
  loader: Loader,
  video: Video,
  modal: Modal,
  layoutSelect: LayoutSelect,
  masonryGrid: MasonryGrid
});
